import {AddressUsage} from '@app/model/order/dcp-order-entry.model';

const addressUsage: typeof AddressUsage = AddressUsage;

export const orderReview: object = {
  orderReview: {
    paymentMethod: 'Payment Method',
    paymentContactsSection: {
      [addressUsage.END_CUST]: {
        title: 'End Customer',
        explainText: 'Your end customer who will be using this solution.',
      },
      [addressUsage.SOLD_TO]: {
        title: 'Sell-To Party',
        explainText: 'The contracting party for this agreement',
      },
      [addressUsage.BILL_TO]: {
        title: 'Bill-To Party',
        explainText: 'The address that will appear on your invoice.',
      },
      [addressUsage.SHIP_TO]: {
        title: 'Ship-To Party (Primary Access Location)',
        explainText: 'The address where the solution will primarily be used (Relevant for determining taxation).'
      },
      [addressUsage.MAIN_CONTACT]: {
        title: 'Main Contact',
        explainText: 'The person who will receive the order confirmation.',
      },
      [addressUsage.IT_CONTACT]: {
        title: 'Technical Administrator',
        explainText: 'The person who will be able to allocate licenses to your users.'
      },
    },
  },
};
